module.exports = __webpack_public_path__ + "img/header-logo.a20230ff.png";